import React, { useState } from 'react';

import { Reveal } from '../../../../components/Reveal';
import { api } from '../../../../services/api';
import {
  Actions,
  ErrorText,
  Field,
  Form,
  Heading,
  Lead,
  Panel,
  ResponseNote,
  Row,
  SubmitButton,
  SuccessBox,
} from './styles';

const ContactForm: React.FC = () => {
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(false);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const formData = new FormData(event.currentTarget);

    setSending(true);
    setError(false);

    try {
      await api.post('leads', {
        name: formData.get('name'),
        email: formData.get('email'),
        phone: formData.get('phone') || undefined,
        profile: formData.get('profile'),
        message: formData.get('message') || undefined,
      });

      setSent(true);
    } catch {
      setError(true);
    } finally {
      setSending(false);
    }
  };

  return (
    <Reveal direction="up">
      <Panel>
        <Heading>Ainda ficou com alguma dúvida?</Heading>
        <Lead>
          Preencha os campos abaixo e a nossa equipe entrará em contato com você
          o mais rápido possível.
        </Lead>

        {sent ? (
          <SuccessBox>
            <div>Mensagem enviada</div>
            <p>
              Obrigado! Um especialista do TrenzoX entrará em contato pelo canal
              informado.
            </p>
          </SuccessBox>
        ) : (
          <Form onSubmit={handleSubmit}>
            <Row>
              <Field>
                Nome completo
                <input
                  name="name"
                  type="text"
                  required
                  placeholder="Seu nome"
                />
              </Field>
              <Field>
                Perfil
                <select name="profile" defaultValue="academia">
                  <option value="academia">Academia / Studio</option>
                  <option value="personal">Personal Trainer</option>
                  <option value="aluno_avulso">Aluno Avulso</option>
                </select>
              </Field>
            </Row>

            <Row>
              <Field>
                E-mail
                <input
                  name="email"
                  type="email"
                  required
                  placeholder="voce@academia.com"
                />
              </Field>
              <Field>
                Telefone / WhatsApp
                <input name="phone" type="tel" placeholder="(00) 00000-0000" />
              </Field>
            </Row>

            <Field>
              Mensagem / dúvida
              <textarea
                name="message"
                rows={4}
                placeholder="Como podemos ajudar?"
              />
            </Field>

            {error && (
              <ErrorText>
                Não foi possível enviar sua mensagem agora. Tente novamente em
                instantes.
              </ErrorText>
            )}

            <Actions>
              <SubmitButton type="submit" disabled={sending}>
                {sending ? 'Enviando...' : 'Enviar mensagem'}
              </SubmitButton>
              <ResponseNote>
                Respondemos geralmente em até 2 horas úteis.
              </ResponseNote>
            </Actions>
          </Form>
        )}
      </Panel>
    </Reveal>
  );
};

export { ContactForm };
